export class PenaltyEntity {

    public static fromDto(dto: any): PenaltyEntity {
        if (!dto) {
            return new PenaltyEntity();
        }
        const entity = new PenaltyEntity();

        entity.adjacentIntervalCount = dto.adjacentIntervalCount;
        entity.extraIntervals = dto.extraIntervals;
        entity.score = dto.score;
        entity.totalSameAssociationAsOpponentCount = dto.totalSameAssociationAsOpponentCount;
        entity.totalSameOpponentAssociationCount = dto.totalSameOpponentAssociationCount;
        entity.totalSameOpponentCount = dto.totalSameOpponentCount;
        entity.notOptimizedTotalTimeCount = dto.notOptimizedTotalTimeCount;
        entity.associationAgainstAssociationCount = dto.associationAgainstAssociationCount;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): PenaltyEntity[] {
        const entities: PenaltyEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = PenaltyEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public score: number = null;
    public adjacentIntervalCount: number = null;
    public totalSameOpponentCount: number = 0;
    public totalSameOpponentAssociationCount: number = 0;
    public totalSameAssociationAsOpponentCount: number = 0;
    public extraIntervals: number = 0;
    public notOptimizedTotalTimeCount: number = 0;
    public associationAgainstAssociationCount: number = 0;

}
